import { Injectable, EventEmitter } from '@angular/core';
import { IBreadcrumb } from '../breadcrumb/breadcrumb.interface';

@Injectable()
export class BreadcrumbService {
  items: IBreadcrumb[] = [];

  public breadcrumbChanged: EventEmitter<IBreadcrumb[]> = new EventEmitter<IBreadcrumb[]>();

  constructor() { }

  getBreadcrumb(): IBreadcrumb[] {
    return this.items;
  }

  setBreadCrumb(breadcurmbs: IBreadcrumb[]):void {
    this.items = breadcurmbs;
    this.breadcrumbChanged.next(this.items);
  }

}
